import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKaiAction = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M9.117 20.983c.24-.657 1.17-.657 1.41 0l1.126 3.087c.228.625.72 1.116 1.345 1.344l3.086 1.125c.657.24.657 1.171 0 1.411l-3.086 1.125a2.252 2.252 0 0 0-1.345 1.345l-1.125 3.087c-.24.657-1.171.657-1.411 0L7.992 30.42a2.252 2.252 0 0 0-1.345-1.345L3.56 27.95c-.657-.24-.657-1.17 0-1.41l3.087-1.126a2.251 2.251 0 0 0 1.345-1.345l1.125-3.086ZM22.724 9.43c.328-.9 1.6-.9 1.93 0l1.539 4.224a3.086 3.086 0 0 0 1.84 1.84l4.225 1.54c.9.328.9 1.602 0 1.93l-4.224 1.54a3.092 3.092 0 0 0-1.841 1.84l-1.54 4.225c-.327.9-1.601.9-1.929 0l-1.539-4.225a3.093 3.093 0 0 0-1.84-1.84l-4.225-1.54c-.9-.328-.9-1.602 0-1.93l4.224-1.54a3.086 3.086 0 0 0 1.841-1.84l1.54-4.224ZM9.668 2.48c.234-.64 1.14-.64 1.373 0l1.095 3.005a2.198 2.198 0 0 0 1.31 1.31l3.006 1.094c.64.235.64 1.14 0 1.374l-3.005 1.096a2.198 2.198 0 0 0-1.31 1.31l-1.097 3.005c-.233.64-1.138.64-1.372 0l-1.095-3.006a2.197 2.197 0 0 0-1.31-1.31L4.257 9.264c-.64-.234-.64-1.14 0-1.374l3.006-1.095a2.197 2.197 0 0 0 1.31-1.31l1.095-3.004Z",
		fill: "currentColor"
	})]
});
const ForwardRef = forwardRef(SvgKaiAction);
export { ForwardRef as ReactComponent };
